import React from "react";
import { Flame } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

const PRODUCTION_URL = "https://smokey-af-bbq.emergent.host";

const W = 1080;
const H = 1350;

const ITEMS = [
  {
    img: "/oktoberfest/schnitzel_plate.png",
    name: "Chicken or Pork Schnitzel",
    desc: "German potato salad · sauerkraut · mushroom gravy",
    price: "$14",
  },
  {
    img: "/oktoberfest/schnitzel_bowl.png",
    name: "Smokey AF Chicken Schnitzel Bowl",
    desc: "Chicken schnitzel · mashed potatoes · mushroom gravy over everything",
    price: "$14",
  },
  {
    img: "/menu/bbq_bavarian_pretzel.png",
    name: "Bavarian Behemoth Pretzel",
    desc: "Warm giant pretzel · dipping sauces",
    price: "$12",
  },
  {
    img: "/oktoberfest/bratwurst.png",
    name: "Grilled German Bratwurst",
    desc: "Grilled brat · roll · mustard · kraut",
    price: "$7",
  },
];

const BavarianStripe = () => (
  <div
    className="w-full flex-shrink-0"
    style={{
      height: 14,
      background:
        "repeating-linear-gradient(45deg, #2C6FB5 0px, #2C6FB5 18px, #fff 18px, #fff 36px)",
    }}
  />
);

export default function OktoberfestAd() {
  return (
    <div className="min-h-screen w-full bg-black flex items-start justify-center">
      <div
        data-testid="oktoberfest-ad-standalone"
        className="relative overflow-hidden flex flex-col bg-black"
        style={{ width: W, height: H }}
      >
        <BavarianStripe />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at 50% 0%, rgba(44,111,181,0.25), transparent 55%), radial-gradient(ellipse at 50% 100%, rgba(255,140,0,0.18), transparent 50%)",
          }}
        />

        {/* Header */}
        <div className="relative text-center mt-8">
          <div className="flex items-center justify-center gap-3">
            <Flame className="w-7 h-7 text-[#FF3B30]" />
            <span className="font-['Anton'] text-3xl tracking-widest uppercase text-white">
              Smokey <span className="text-[#FF3B30]">AF</span> Barbecue
            </span>
            <Flame className="w-7 h-7 text-[#FF3B30]" />
          </div>
          <h1
            className="font-['Anton'] uppercase leading-[0.9] mt-4"
            style={{ fontSize: 110, color: "#F6B93B", textShadow: "0 4px 30px rgba(0,0,0,0.9)" }}
          >
            Oktoberfest
          </h1>
          <p className="font-['Outfit'] uppercase tracking-[0.5em] text-white mt-3 text-2xl">
            at Southern Style
          </p>
          <p className="font-['Outfit'] uppercase tracking-[0.3em] text-[#2C9FE8] mt-2 text-base">
            German eats · Smokey AF style · Limited time
          </p>
        </div>

        {/* Items grid */}
        <div className="relative grid grid-cols-2 gap-5 px-12 mt-8 flex-1">
          {ITEMS.map((it) => (
            <div
              key={it.name}
              className="relative border-2 border-white/20 bg-black/60 overflow-hidden flex flex-col"
            >
              <div className="relative flex-1 overflow-hidden" style={{ minHeight: 220 }}>
                <img
                  src={it.img}
                  alt={it.name}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute top-3 right-3 bg-[#FF3B30] text-white font-['Anton'] px-4 py-1.5 rotate-2"
                  style={{ fontSize: 34 }}
                >
                  {it.price}
                </div>
              </div>
              <div className="px-4 py-3">
                <div
                  className="font-['Anton'] uppercase tracking-tight text-white leading-none"
                  style={{ fontSize: 26 }}
                >
                  {it.name}
                </div>
                <div
                  className="font-['Outfit'] uppercase tracking-[0.15em] text-zinc-300 mt-1.5"
                  style={{ fontSize: 13 }}
                >
                  {it.desc}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="relative mx-12 mt-5 mb-5 border-t border-white/25 pt-4 flex items-center justify-between gap-6">
          <div>
            <div className="font-['Anton'] uppercase tracking-widest text-white" style={{ fontSize: 24 }}>
              Southern Style · 648 N Broad St, Fremont NE
            </div>
            <div className="font-['Outfit'] uppercase tracking-[0.3em] text-[#F6B93B] mt-2" style={{ fontSize: 16 }}>
              Prost! 🍺 Dine In · Scan to Order →
            </div>
          </div>
          <div className="bg-white flex-shrink-0" style={{ padding: 6 }}>
            <QRCodeSVG
              value={PRODUCTION_URL}
              size={92}
              level="H"
              bgColor="#ffffff"
              fgColor="#000000"
            />
          </div>
        </div>
        <BavarianStripe />
      </div>
    </div>
  );
}
